'use client';

import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useCountry } from '@/context/CountryContext';

interface AppLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

export default function AppLayout({ children, title, subtitle }: AppLayoutProps) {
  const { code } = useCountry();

  return (
    <div className="flex h-screen overflow-hidden bg-surface-light">
      <Sidebar />
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Header title={title} subtitle={subtitle} />
        <main key={code} className="flex-1 overflow-y-auto p-6 animate-fade-in">
          {children}
        </main>
      </div>
    </div>
  );
}